module.exports = __webpack_public_path__ + "img/logo_strata.19f56b17.png";